import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card bg-warning-soft\"><div class=\"card-body\"><div class=\"d-flex align-items-center mb-3\"><i class=\"fa-solid fa-circle-exclamation me-2 text-warning\"></i><p class=\"mb-0 text-subtitle\">Importante</p></div><p class=\"text-paragraph\"> Se você alterar o valor da sessão e tiver cupons de desconto, lembre-se de que qualquer valor de cupom inferior a 50 reais será ajustado automaticamente para 50 reais como mínimo. </p></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-exclamation me-2 text-primary" }),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-subtitle" }, "Lembrete:")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", { class: "text-primary text-paragraph ps-4" }, [
  /*#__PURE__*/_createElementVNode("li", null, " É descontado uma taxa de 20% em cima do valor das sessões realizadas. "),
  /*#__PURE__*/_createElementVNode("li", null, "Valor mínimo aceito para qualquer tipo de sessão é de R$50.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyInput = _resolveComponent("MoneyInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_MoneyInput, {
      required: "",
      label: `Valor da sessão agendada`,
      model: _ctx.v$.form.appointment_price,
      errorMsg: _ctx.v$.form.appointment_price.required?.$message
    }, null, 8, ["model", "errorMsg"]),
    _createVNode(_component_MoneyInput, {
      required: "",
      label: `Valor da conversa inicial`,
      model: _ctx.v$.form.first_appointment_price,
      errorMsg: _ctx.v$.form.first_appointment_price.required?.$message
    }, null, 8, ["model", "errorMsg"]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_FormButton, {
      label: "Concluir",
      disabled: _ctx.v$.$invalid,
      onOnClick: _ctx.submit,
      loading: _ctx.submitting,
      form: _ctx.v$.form
    }, null, 8, ["disabled", "onOnClick", "loading", "form"])
  ]))
}